export class SectionStyle {

    public static curSectionId: number = 0;
    public static curPrintSectionId: number = null;
    protected style: CSSStyleDeclaration;

    constructor(data?: any) {
        this.init(data);
    }

    protected init(data?: string): void {
        if (!data || typeof data === 'string') {
            this.setStyle(data);
        } else {
            this.style = data;
        }
    }

    public static getCurrentClass(isPrint?: boolean): string {
        return `cont-${SectionStyle.getCurrentId(isPrint)}`;
    }

    public static getCurrentId(isPrint?: boolean): string {
        const id: number = isPrint ? SectionStyle.curPrintSectionId : SectionStyle.curSectionId;

        switch (id) {
            case 0: return 'dateneingabe';
            case 1: return 'datenauswertung';
            // case 3: return 'zusatztools';
            case 2: return 'zusatztools';
            // case 4: return 'informationen_hilfe';
            case 3: return 'informationen_hilfe';
            default: return 'dateneingabe';
        }
    }

    public getPropertyValue(name: string): string {
        return this.style ? this.style.getPropertyValue((name || '').toString()) : null;
    }

    public getPropertyValues(names: string[]): string[] {
        return (names || []).map((name: string) => this.getPropertyValue(name));
    }

    public static getSectionColors(): any {
        const colors: any = {};
        const sections: string[] = ['datenauswertung', 'dateneingabe', 'informationen_hilfe', 'zusatztools'];
        const Section: any = new SectionStyle();

        sections.forEach((section: string) => {
            colors[section] = Section.getPropertyValue(`--color-main-section-${section}`);
        });

        return colors;
    }

    public getStyle(): CSSStyleDeclaration {
        return this.style;
    }

    protected setStyle(name?: string): void {
        const elements: HTMLCollection = document.getElementsByClassName(name || 'react-tabs__tab-panel--selected');
        this.style = elements.length ? window.getComputedStyle(elements[0]) : null;
    }
}
